import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

const CLIENT_KEYS = ["clients"];

export const useViewClientQuery = ({ page, limit, q } = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";

  return useQuery({
    queryKey: isPaginated
      ? ["viewClient", page, limit, trimmedQ]
      : ["viewClient"],
    queryFn: async () => {
      const params = {};
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
      }

      const res = await api.get("/client/list", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(res.data, CLIENT_KEYS, limit);
        return {
          clients: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData) => previousData
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
  });
};
